export default {
  PPST_RATE: 140,
  SUCCESS: 'Success',
  ERROR: 'Error',
  JWT: 'jwt',
  UNAUTHORIZED_CODE: 401,
  INVALID_TOKEN: 403,
  LANGUAGE_LINK: '',
  usdtContract: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  testContract: '0x12575791dD33E16Cc45b1683a29b6b6E321E09FE',
  RPC_URL_ACTION: {
    TRANSFER: '0xa9059cbb'
  },
  FEE_TYPE: {
    PERCENT: 'percent',
    FIXED: 'fix',
    NONE: 'none'
  },
  PRICE_LINK: 'https://www.binance.com/api/v3/ticker/24hr',
  DELAY_TIME: 1800,
  DEPOSIT_TIME: 100000,
  COLORS_LEVEL: {
    USER: '#666060',
    STARTER: '#A9A8A9',
    R1: '#898989',
    R2: '#408ffc',
    R3: '#005830',
    R4: '#6E47CE',
    R5: '#E4A11E',
    R6: '#F77F15',
    R7: '#CD3C7F',
    R8: '#A51E1B',
    R0: '#A9A8A9'
  },
  BASE_COLOR: '#071435',
  LOCAL_STORE: {
    CONNECTED_TYPE: 'RRG_connectedType',
    IS_CONNECTED: 'RRG_isConnected'
  },
  TYPES_CONNECT: {
    INJECT: 1,
    WALLET_CONNECT: 2
  },
  CONFIG_RPC: {
    56: 'https://bsc-dataseed.binance.org/',
    97: 'https://data-seed-prebsc-1-s1.binance.org:8545',
    1: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'
  }
}
